import "./styles/Header.scss";
import React, {useState, useEffect} from 'react'; 
import logo from "../Images/Logos/JV-D&D-Logo.svg"; 

const Header = () => {

    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if(window.scrollY > 100){
                setIsScrolled(true);
            }
            else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
        
    }, []);

    const Navigation = [
        {
            title: "About",
            link: "/#about"
        },
        {
            title: "My Skills",
            link: "/#skills"
        },
        {
            title: "Projects",
            link: "/#projects"
        },
        {
            title: "Contact",
            link: "/#contact"
        }
    ]; 

    const NavOutput = Navigation.map((nav,i,arr) => 
        <li className="navigation-list-items">
            <a href={nav.link} className="code-array-word">"{nav.title}"
            {i !== arr.length - 1 ? <span>,</span> : false}
            </a>
        </li>
    );
    return(
        <div className={isScrolled ? 'header scrolled' : 'header'}>
            <div className="header-content container">
                <div className="logo">
                    <a className="logo-link" href="/">
                        <img className="logo-img" src={logo} alt="J V logo" /> 
                    </a>
                </div>
                <div className="navigation-container">
                    <p className="code-snippet">let <span className="variable-color">Navigation</span> = [</p>
                    <ul className="navigation">
                        {NavOutput}
                    </ul>
                    <p className="code-snippet">];</p>
                </div>
            </div>
        </div>
    );
}

export default Header; 